// @core/api/endpoints/fiscalization/create_fiscal_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateFiscalPolicyRequest,
  FiscalPolicyResponse,
} from '../../../types/fiscalization';

const BASE_PATH = '/fiscalization';

/**
 * Create fiscal policy
 * Creates a fiscalization policy for a scope entity defining provider, fiscal point, taxation system, and auto-fiscalize behavior.
 */
export async function CreateFiscalPolicy(
  data: CreateFiscalPolicyRequest,
  options?: RequestOptions
): Promise<FiscalPolicyResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/fiscal-policies`;
  const requestOptions = options;
  return client.post<FiscalPolicyResponse>(requestPath, data, requestOptions);
}
